import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { clsx } from 'clsx';
import {
    DASHBOARD_ICON_SIZES,
    TONE_ICON_CLASSES,
    VARIANT_DEFAULT_SIZE,
    type DashboardIconSize,
    type DashboardIconTone,
    type DashboardIconVariant,
} from './dashboardIconConfig';

type Props = {
    icon: LucideIcon;
    variant?: DashboardIconVariant;
    tone?: DashboardIconTone;
    size?: DashboardIconSize;
    className?: string;
    'aria-hidden'?: boolean;
};

export const DashboardIcon: React.FC<Props> = ({
    icon: Icon,
    variant = 'inline',
    tone = 'neutral',
    size,
    className,
    'aria-hidden': ariaHidden = true,
}) => {
    const resolvedSize = size ?? VARIANT_DEFAULT_SIZE[variant];
    const iconClass = clsx(DASHBOARD_ICON_SIZES[resolvedSize], TONE_ICON_CLASSES[tone]);

    if (variant === 'tile' || variant === 'stat') {
        return (
            <span
                className={clsx(
                    'inline-flex items-center justify-center shrink-0',
                    variant === 'tile' ? 'p-2 rounded-lg' : 'p-1.5 rounded-md',
                    'bg-canvas-surface/80 dark:bg-muted/40',
                    className,
                )}
                aria-hidden={ariaHidden}
            >
                <Icon className={iconClass} aria-hidden />
            </span>
        );
    }

    return (
        <Icon
            className={clsx(
                'shrink-0',
                DASHBOARD_ICON_SIZES[resolvedSize],
                variant === 'section' ? TONE_ICON_CLASSES[tone] : undefined,
                className,
            )}
            aria-hidden={ariaHidden}
        />
    );
};
